import {AssessmentItemsEN} from "./assessment-items/en";
import {AssessmentTemplateEN} from "./assessment-template/en";

export const CompetencyAssessmentEN = {
    "assessment": {
        breadcrumb: "Assessment Employee List",
        "headingLabel": "Competency Assessment",
        "heading": {
            "competencyAssessmentList": "Competency Assessment List",
            "add": "Create a new Assessment CurrentEmployee",
            update: "Update a Assessment CurrentEmployee",
            "assessmentEvaluators": "Assessment Evaluators",
            "generalInformation": "General Infomation",
            "employeeList": "Personnel List",

            assessmentEmployeeDetail: "Result of evaluation",
            "assessmentEmployee": "Assessment CurrentEmployee",
            score: "Personnel grading details"
        },
        "sider": {
            "listAssessmentItem": "Competency Library",
            "listAssessmentTemplate": "Assessment Template",
            "listAssessment": "Assessment Period"
        },
        "label": {
            "criteria": {
                "name": "Name",
                "point": "Point",
                "proportion": "Proportion",
                "isEqual": "Equal proportion"
            },
            total: "Total",
            status: "Status",
            "employee": "Name",
            code: "CurrentEmployee Code",
            "assessmentEmployee": {
                "name": "Name",
                "status": "Status",
                "criteriaAmount": "Number of criteria",
                "employeeAmount": "Number of employee",
                "template": "Assessment Template",
                "isTemplate": "Choose from Assessment Template",
                "type": "Type",
                "periodType": "Period Type",
                "month": "Month",
                "year": "Year",
                "crop": "Crop",
                "quarter": "Quarter",
                "startDate": "Start Date",
                "endDate": "End Date",
                "deadline": "Deadline",
                "supervisor": "Supervisor",
                "managers": "Manager",
                "isSequential": "Sequential",
                "createDate": "Create Date",
                "department": "Department",
                position: "Job Position",
                workingDate: "Join Date",
                order: "Order",
                pointStatus: "Score Status"
            },
            "assessmentEvaluator": {
                "evaluator": "Evaluator",
                "type": "Evaluation board"
            },
            assessmentEmployeeDetail: {
                "name": "Critertia",
                proportion: "Proportion",
                benchmark: "Benchmark",
            }
        },
        "value": {
            quarter: {
                one: "Quarter One",
                two: "Quarter Two",
                three: "Quarter Three",
                four: "Quarter Four",
            },
            crop: {
                first: "The first 6 months of the year",
                last: "The last 6 months of the year",
            },
            "point": {
                "0": "Point 1",
                "1": "Point 2",
                "2": "Point 3",
                "3": "Point 4",
                "4": "Point 5"
            },
            "isEqual": {
                "yes": "yes",
                "no": "no"
            },
            sequential: {
                yes: "Sequential",
                no: "Parallel"
            },
            "status": {
                "pending": "Pending",
                "approved": "Approved",
                "trashed": "Trashed",
                "waiting": "Waiting",
                "expired": "Expired",
                "pass": "Pass",
                "notPass": "Not pass"
            },
            "type": {
                "transfer": "Assessment Contract Transfer",
                "periodic": "Assessment Period"
            },
            "periodType": {
                "month": "Month",
                "year": "Year",
                "quarter": "Quarter",
                "crop": "Crop",
                "random": "Random"
            },
            "month": {
                "1": "January",
                "2": "February",
                "3": "March",
                "4": "April",
                "5": "May",
                "6": "June",
                "7": "July",
                "8": "August",
                "9": "September",
                "10": "October",
                "11": "November",
                "12": "December"
            },
            assessmentEvaluator: {
                "type": {
                    "personel": "Personnel Assessment",
                    "directorate": "Directorate Assessment",
                    "partner": "Partner Assessment",
                    "manager": "Manager Assessment",
                    "admainistrative": "Admainistrative Assessment"
                }
            }
        },
        "placeholder": {
            "name": "Enter name",
            "point": "Enter point",
            "proportion": "Enter proportion"
        },
        "action": {
            "status": "Update status",
            "detail": "View Detail",
            "point": "Mark"
        },
        "required": {
            assessmentEmployeeDetail: "At least 1 personnel",
            month: "Month Required",
            year: "Year Required",
            crop: "Crop Required",
            quarter: "Quarter Required",
            startDate: "Start Date Required",
            endDate: "End Date Required",
            deadline: "Deadline Required",
            personnel: "Personnel Required",
            point: "Point Required",
            assessmentEmployee: {
                name: "Name Required",
                type: "Type required",
                template: "Template Required",
                supervisor: "Supervisor Required",
                manager: "Manager Required"
            },
            assessmentEvaluator: {
                type: "Evaluation Board Required",
                evaluator: "Evaluator Required",
                main: "At least 1 Assessment Evaluator",
            }
        },
        "message": {
            "status": "Update Status Success",
            "criteria": {
                "required": {
                    "name": "Name Required",
                    "point": "Point Required",
                    "proportion": "Proportion Required",
                    main: "At least 1 Assessment Criteria",
                }
            },
            error: "Please fill in all required information"
        }
    },
    ...AssessmentItemsEN,
    ...AssessmentTemplateEN
}